
const local = {
    CLIENT_ID: "b02712f7-f304-4bb1-ac80-82bc8495ec9a",
    REDIRECT_URL: "http://localhost:3000/events",
    AUTHORIZATION: "Basic YjAyNzEyZjctZjMwNC00YmIxLWFjODAtODJiYzg0OTVlYzlhOmNmZGUyNTQ3NDBmODQyZjJiOTlhNDczZjk0YWEzY2Y4",
    TID_AUTHORIZE: "https://stage.id.trimblecloud.com/oauth/authorize",
    TID_OUTH: "https://stage.id.trimblecloud.com/oauth/token",
    EVENTS_ENDPOINT: "https://cloud.dev.api.trimblecloud.com/events/asyncapi/v1",
    SCOPE: 'events-asyncapi-stg'
};

const dev = {
    CLIENT_ID: "b02712f7-f304-4bb1-ac80-82bc8495ec9a",
    REDIRECT_URL: "https://d3szgk3yxbo1xe.cloudfront.net/events",
    AUTHORIZATION: "Basic YjAyNzEyZjctZjMwNC00YmIxLWFjODAtODJiYzg0OTVlYzlhOmNmZGUyNTQ3NDBmODQyZjJiOTlhNDczZjk0YWEzY2Y4",
    TID_OUTH: "https://stage.id.trimblecloud.com/oauth/token",
    TID_AUTHORIZE: "https://stage.id.trimblecloud.com/oauth/authorize",
    EVENTS_ENDPOINT: "https://cloud.dev.api.trimblecloud.com/events/asyncapi/v1",
    SCOPE: 'events-asyncapi-stg'
};

const prod = {

      CLIENT_ID: "ba952758-57ec-4460-9633-eca3cd450ba7",
      REDIRECT_URL: "https://asyncapi.stage.events.trimblecloud.com/events",
      AUTHORIZATION: "Basic YmE5NTI3NTgtNTdlYy00NDYwLTk2MzMtZWNhM2NkNDUwYmE3OjIzMTlmNDRjMzYxNjQ4Nzc5MTljYjQ4YTgyODU4MGIy",
      TID_OUTH: "https://id.trimble.com/oauth/token",
      TID_AUTHORIZE: "https://id.trimble.com/oauth/authorize",
      EVENTS_ENDPOINT: "https://cloud.api.trimble.com/events/asyncapi/v1" ,
      SCOPE: 'EventsAsyncapi'

  };
  
  const config = process.env.REACT_APP_STAGE === 'prod'
    ? prod
    : process.env.REACT_APP_STAGE === 'dev' ? dev : local;
  

export default config;